import BookSegmentManagement from "./book-segment-management.page";

export default BookSegmentManagement;
